import { render } from "./LightboxCategoryMostPurchasedSkeleton.vue?vue&type=template&id=929edef0&scoped=true"
import script from "./LightboxCategoryMostPurchasedSkeleton.vue?vue&type=script&lang=js"
export * from "./LightboxCategoryMostPurchasedSkeleton.vue?vue&type=script&lang=js"

import "./LightboxCategoryMostPurchasedSkeleton.vue?vue&type=style&index=0&id=929edef0&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-929edef0"]])

export default __exports__